import { MainLayout, utils, AreYouSure, i18n, Portal, CurrentPortal } from '@common';
import { accountService } from "@api";
import './index.less';
export default class Layout extends R.Component {
    componentCreate() {
        this.componentId = "student-layout";
        this.handleLogout = this.handleLogout.bind(this);
        CurrentPortal.set(Portal.Student);
    }
    componentInit() {
        const { history } = this.props;
        utils.__redirectByRouter = function (url) {
            if (!history) {
                return utils.redirectHref(url);
            }
            return history.push(url);
        };
    }
    signoutClick() {
        AreYouSure.checkWithConfirm(null, () => {
            utils.sessionControl.signout();
        });
    }
    handleLogout() {
        $$.loading(true);
        accountService.getCurrentUser().then(res => {
            Promise.all([
                accountService.logout(),
                accountService.regoLogin(`${utils.getOriginUrl()}/student`),
                accountService.logoutIDP()
            ]).then(([logout, regoLogin, logoutidp]) => {
                $$.loading(false);
                const redirectTo = `${logout.detail}?redirect_uri=${encodeURIComponent(logoutidp?.detail ? logoutidp?.detail : regoLogin?.detail)}`;
                utils.redirectTo(redirectTo);
            }).catch(e => {
                $$.loading(false);
                throw e;
            });
        }).catch(err => {
            utils.redirectTo('/error/studentsessionexpired');
            $$.loading(false);
        });
    }
    render() {
        return (
            <MainLayout
                portal="student"
                history={this.props.history}
                logo={this.props.logo}
                renderButtons={
                    <div className='logout-btn' onClick={this.handleLogout}>{i18n.get('CIS_Student_Head_Nav_Logout_Entry')}</div>
                }
            >
                {this.props.children}
            </MainLayout>
        );
    }
}

